<template>
  <div>
    <span
      @mouseenter="showTransferInfo = true"
      @mouseleave="showTransferInfo = false"
      >{{ creatorName }}</span
    >
    <div v-if="showTransferInfo && task.transfer.length > 0" class="tag-table">
      <div class="table-responsive">
        <table class="table table-condensed">
          <!--                    <thead>-->
          <!--                    <tr>-->
          <!--                        <th scope="col">Transfer By</th>-->
          <!--                        <th scope="col">Transfer To</th>-->
          <!--                        <th scope="col">Transferred On</th>-->
          <!--                    </tr>-->
          <!--                    </thead>-->
          <tbody>
            <tr v-for="(transfer, index) in task.transfer" :key="index">
              <td>{{ transfer.transfer_by.full_name }}</td>
              <td>{{ transfer.transfer_to.full_name }}</td>
              <td>{{ transfer.created_at | shortDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import moment from "moment";

export default {
  name: "TaskFromUser",
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      creatorName: null,
      transferHistory: [],
      showTransferInfo: false
    };
  },
  mounted() {
    this.getCreatorName();
  },

  methods: {
    getCreatorName() {
      this.task.task_assignment.forEach(assign => {
        //if this is not the creator and he has not transferred the task, then the name of the person who transferred to him will be shown.
        if (
          assign.assigned_to.id === this.auth.user.id &&
          assign.assigned_by.id !== this.auth.user.id
        ) {
          this.creatorName = assign.assigned_by.full_name;
        }

        //If it is the original creator of the task, his name will be shown.
        if (assign.assigned_to.id === assign.assigned_by.id) {
          this.creatorName = assign.assigned_by.full_name;
        }
      });
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY ");
    }
  },

  computed: {
    ...mapState("user", ["auth"])
  }
};
</script>

<style scoped>
.tag-table {
  position: absolute;
  right: 82px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: max-content;
  background-color: #fff;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  padding: 5px;
}
</style>
